
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[subdomain]/audio",
      function () {
        return require("private-next-pages/page/[subdomain]/audio.tsx");
      }
    ]);
  